import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

export const ENDPOINT = `${APIConfiguration.owner}orders/salesReceipt`;

interface GetOrdersFromSalesReceiptQueryArgs {
  sellerId: string;
  receiptNumber: string;
  storeId: string;
  purchaseDateUtc: string;
}

export const getOrdersFromSalesReceiptQuery = async ({
  sellerId,
  receiptNumber,
  storeId,
  purchaseDateUtc,
}: GetOrdersFromSalesReceiptQueryArgs): Promise<
  BackResponse<string> | BackResponseFailure
> => {
  try {
    const response = await apiCall<BackResponse<string>>(
      buildUrl(ENDPOINT, {
        sellerId,
        receiptNumber,
        storeId,
        purchaseDateUtc,
      }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
